module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_vm._v("To Amina"), _c('br'), _vm._v("\nFor your love, for your laughter"), _c('br'), _vm._v("\nand for standing firm when weaker hearts succumb"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("And to Darius, my eternal love"), _c('br'), _vm._v("\nI hope to be as good of a parent to you as my parents were to me")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46588f3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/04-dedication.vue
// module id = 66
// module chunks = 0